var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.readingFile)?_c('upload',{attrs:{"change":_vm.inputUploadChange,"accept":"excel","text":"Selecione um arquivo para importar"}}):_vm._e(),(_vm.readingFile)?_c('div',{staticClass:"process-spinner"},[_c('load-placeholder',{attrs:{"loading":_vm.readingFile,"color-a":'#7d7e7f',"color-b":'#7d7e7f'}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }